import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { isFlowEngineGloballyEnabled } from "../../app/helpers/flowEngineConfigHelper";

const FlowEngineGlobalGate = ({ children, redirectTo = "/home" }) => {
  const { t } = useTranslation();
  const configuration = useSelector((state) => state.configuration);
  const enabled = isFlowEngineGloballyEnabled(configuration);

  if (!enabled) {
    return (
      <div className="container py-4">
        <div className="alert alert-info mb-3">
          {t(
            "general.flow-engine.disabled-global",
            "El motor de flujos está desactivado. Esta sección no está disponible."
          )}
        </div>
        <Navigate to={redirectTo} replace />
      </div>
    );
  }

  return children;
};

FlowEngineGlobalGate.propTypes = {
  children: PropTypes.node.isRequired,
  redirectTo: PropTypes.string
};

export default FlowEngineGlobalGate;
